/* unplugin-vue-components disabled */import { ElTimeline as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/timeline/style/css';
import { ElTimelineItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/timeline-item/style/css';
import { ElCard as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/card/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  "class": "content"
};
import { processApi } from '@/api/international';
export default /*@__PURE__*/_defineComponent({
  __name: 'International_3',
  setup: function setup(__props) {
    var processData = ref([]);
    onMounted(function () {
      processApi().then(function (res) {
        var _res$data;
        processData.value = (_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : [];
      });
    });
    return function (_ctx, _cache) {
      var _component_el_card = __unplugin_components_0;
      var _component_el_timeline_item = __unplugin_components_1;
      var _component_el_timeline = __unplugin_components_2;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_timeline, {
        "class": "timeline"
      }, {
        "default": _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(processData), function (activity, index) {
            return _openBlock(), _createBlock(_component_el_timeline_item, {
              key: index,
              "class": _normalizeClass(index % 2 === 0 ? 'timeline-left' : 'timeline-right'),
              timestamp: activity.year,
              placement: "top"
            }, {
              "default": _withCtx(function () {
                return [_createVNode(_component_el_card, null, {
                  "default": _withCtx(function () {
                    return [_createElementVNode("h4", null, _toDisplayString(activity.context), 1)];
                  }),
                  _: 2
                }, 1024)];
              }),
              _: 2
            }, 1032, ["class", "timestamp"]);
          }), 128))];
        }),
        _: 1
      })]);
    };
  }
});